import React, {useEffect, useRef, useState} from 'react';
import {Platform} from 'react-native';

import {BalloonContainer, BalloonText, BalloonTail} from './styles';

const BALLOON_TEXTS = ['Ative seu desconto', 'Pague menos usando BaratinhaZ'];
const TYPING_SPEED_MS = 60;
const RESTART_DELAY_MS = 10000;

export function BaratinhasDiscountBalloon() {
  if (Platform.OS === 'web') {
    return null;
  }

  const [visibleCount, setVisibleCount] = useState(0);
  const [textIndex, setTextIndex] = useState(0);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const clearTimers = () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };

    const startTyping = () => {
      setVisibleCount(0);
      const currentText = BALLOON_TEXTS[textIndex] ?? '';
      intervalRef.current = setInterval(() => {
        setVisibleCount((prev) => {
          if (prev >= currentText.length) {
            clearTimers();
            timeoutRef.current = setTimeout(() => {
              setTextIndex((currentIndex) =>
                (currentIndex + 1) % BALLOON_TEXTS.length,
              );
            }, RESTART_DELAY_MS);
            return prev;
          }
          return prev + 1;
        });
      }, TYPING_SPEED_MS);
    };

    startTyping();

    return () => {
      clearTimers();
    };
  }, [textIndex]);

  const currentText = BALLOON_TEXTS[textIndex] ?? '';

  return (
    <BalloonContainer>
      <BalloonText>{currentText.slice(0, visibleCount)}</BalloonText>
      <BalloonTail />
    </BalloonContainer>
  );
}
